function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ee7624",
  d: "M12 0a12 12 0 1012 12A12 12 0 0012 0zm4.915 16.373a.377.377 0 010 .544.344.344 0 01-.27.115.354.354 0 01-.272-.115L12 12.542l-4.375 4.375a.344.344 0 01-.27.115.354.354 0 01-.272-.115.377.377 0 010-.544L11.458 12 7.083 7.627a.384.384 0 11.542-.544L12 11.458l4.373-4.375a.384.384 0 11.542.544L12.542 12z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  r: 12,
  cx: 12,
  cy: 12,
  fill: "#ee7624"
});

function SvgWrongIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongIcon);
export default __webpack_public_path__ + "static/media/wrong-icon.45bfdab6.svg";
export { ForwardRef as ReactComponent };